import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/login/man.jpg'
import _imports_1 from '@/assets/images/login/woman.jpg'
import _imports_2 from '@/assets/images/login/woman2.jpg'
import _imports_3 from '@/assets/images/login/man2.jpg'
import _imports_4 from '@/assets/images/login/woman3.jpg'
import _imports_5 from '@/assets/images/login/man3.jpg'


const _hoisted_1 = { id: "login" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"background-img\" alt=\"Profile 1\"><img src=\"" + _imports_1 + "\" class=\"background-img\" alt=\"Profile 4\"><img src=\"" + _imports_2 + "\" class=\"background-img\" alt=\"Profile 2\"><img src=\"" + _imports_3 + "\" class=\"background-img\" alt=\"Profile 3\"><img src=\"" + _imports_4 + "\" class=\"background-img\" alt=\"Profile 5\"><img src=\"" + _imports_5 + "\" class=\"background-img\" alt=\"Profile 3\">", 6)
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Digite seu e-mail "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Digite sua senha "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1)
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_22 = [
  _hoisted_16
]
const _hoisted_23 = { class: "remember-recover" }
const _hoisted_24 = { for: "remember" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Ficar logado", -1)
const _hoisted_27 = {
  class: "recaptcha",
  style: {"display":"flex","justify-content":"center","margin":"0 0 15px 0"}
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"bottom-links\"><a href=\"https://wa.me/5585997277128\">Fale conosco</a><a href=\"#\">Solicitar demonstração</a></div><div class=\"social-links\"><a href=\"https://www.instagram.com/fluxoosoft\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\"><path d=\"M27.3334 14C27.3334 6.64002 21.3601 0.666687 14.0001 0.666687C6.64008 0.666687 0.666748 6.64002 0.666748 14C0.666748 20.4534 5.25341 25.8267 11.3334 27.0667V18H8.66675V14H11.3334V10.6667C11.3334 8.09335 13.4267 6.00002 16.0001 6.00002H19.3334V10H16.6667C15.9334 10 15.3334 10.6 15.3334 11.3334V14H19.3334V18H15.3334V27.2667C22.0667 26.6 27.3334 20.92 27.3334 14Z\" fill=\"#079F72\"></path></svg></a><a href=\"https://www.instagram.com/fluxoosoft\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\"><path d=\"M17.3708 2.66669C18.8708 2.67069 19.6321 2.67869 20.2894 2.69735L20.5481 2.70669C20.8468 2.71735 21.1414 2.73069 21.4974 2.74669C22.9161 2.81335 23.8841 3.03735 24.7334 3.36669C25.6134 3.70535 26.3548 4.16402 27.0961 4.90402C27.7744 5.57033 28.299 6.37665 28.6334 7.26669C28.9628 8.11602 29.1868 9.08402 29.2534 10.504C29.2694 10.8587 29.2828 11.1534 29.2934 11.4534L29.3014 11.712C29.3214 12.368 29.3294 13.1294 29.3321 14.6294L29.3334 15.624V17.3707C29.3367 18.3432 29.3265 19.3158 29.3028 20.288L29.2948 20.5467C29.2841 20.8467 29.2708 21.1414 29.2548 21.496C29.1881 22.916 28.9614 23.8827 28.6334 24.7334C28.299 25.6234 27.7744 26.4297 27.0961 27.096C26.4298 27.7743 25.6235 28.2989 24.7334 28.6334C23.8841 28.9627 22.9161 29.1867 21.4974 29.2534L20.5481 29.2934L20.2894 29.3014C19.6321 29.32 18.8708 29.3294 17.3708 29.332L16.3761 29.3334H14.6308C13.6578 29.3368 12.6848 29.3266 11.7121 29.3027L11.4534 29.2947C11.1369 29.2827 10.8205 29.2689 10.5041 29.2534C9.08544 29.1867 8.11744 28.9627 7.26677 28.6334C6.37721 28.2988 5.57136 27.7741 4.90544 27.096C4.2267 26.4298 3.70159 25.6235 3.36677 24.7334C3.03744 23.884 2.81344 22.916 2.74677 21.496L2.70677 20.5467L2.70011 20.288C2.67553 19.3158 2.66442 18.3432 2.66677 17.3707V14.6294C2.66308 13.6568 2.67286 12.6843 2.69611 11.712L2.70544 11.4534C2.71611 11.1534 2.72944 10.8587 2.74544 10.504C2.81211 9.08402 3.03611 8.11735 3.36544 7.26669C3.70103 6.37628 4.22707 5.56994 4.90677 4.90402C5.57231 4.22609 6.37769 3.70145 7.26677 3.36669C8.11744 3.03735 9.08411 2.81335 10.5041 2.74669C10.8588 2.73069 11.1548 2.71735 11.4534 2.70669L11.7121 2.69869C12.6844 2.675 13.6569 2.66477 14.6294 2.66802L17.3708 2.66669ZM16.0001 9.33335C14.232 9.33335 12.5363 10.0357 11.2861 11.286C10.0358 12.5362 9.33344 14.2319 9.33344 16C9.33344 17.7681 10.0358 19.4638 11.2861 20.7141C12.5363 21.9643 14.232 22.6667 16.0001 22.6667C17.7682 22.6667 19.4639 21.9643 20.7142 20.7141C21.9644 19.4638 22.6668 17.7681 22.6668 16C22.6668 14.2319 21.9644 12.5362 20.7142 11.286C19.4639 10.0357 17.7682 9.33335 16.0001 9.33335ZM16.0001 12C16.5254 11.9999 17.0456 12.1033 17.5309 12.3042C18.0162 12.5052 18.4572 12.7998 18.8287 13.1711C19.2002 13.5425 19.4949 13.9834 19.696 14.4687C19.8971 14.9539 20.0007 15.4741 20.0008 15.9994C20.0009 16.5246 19.8975 17.0448 19.6965 17.5301C19.4956 18.0155 19.201 18.4565 18.8297 18.828C18.4583 19.1995 18.0174 19.4942 17.5321 19.6953C17.0469 19.8964 16.5267 19.9999 16.0014 20C14.9406 20 13.9232 19.5786 13.173 18.8284C12.4229 18.0783 12.0014 17.0609 12.0014 16C12.0014 14.9392 12.4229 13.9217 13.173 13.1716C13.9232 12.4214 14.9406 12 16.0014 12M23.0014 7.33335C22.5594 7.33335 22.1355 7.50895 21.8229 7.82151C21.5104 8.13407 21.3348 8.55799 21.3348 9.00002C21.3348 9.44205 21.5104 9.86597 21.8229 10.1785C22.1355 10.4911 22.5594 10.6667 23.0014 10.6667C23.4435 10.6667 23.8674 10.4911 24.18 10.1785C24.4925 9.86597 24.6681 9.44205 24.6681 9.00002C24.6681 8.55799 24.4925 8.13407 24.18 7.82151C23.8674 7.50895 23.4435 7.33335 23.0014 7.33335Z\" fill=\"#079F72\"></path></svg></a><a target=\"_blank\" href=\"https://www.instagram.com/fluxoosoft\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0001 5.33331C17.1401 5.33331 18.3094 5.36265 19.4427 5.41065L20.7814 5.47465L22.0627 5.55065L23.2627 5.63198L24.3587 5.71731C25.5483 5.80783 26.6678 6.31523 27.52 7.15012C28.3722 7.98501 28.9025 9.09384 29.0174 10.2813L29.0707 10.848L29.1707 12.0613C29.2641 13.3186 29.3334 14.6893 29.3334 16C29.3334 17.3106 29.2641 18.6813 29.1707 19.9386L29.0707 21.152L29.0174 21.7186C28.9024 22.9063 28.372 24.0153 27.5195 24.8502C26.667 25.6852 25.5472 26.1924 24.3574 26.2826L23.2641 26.3666L22.0641 26.4493L20.7814 26.5253L19.4427 26.5893C18.2959 26.639 17.148 26.6648 16.0001 26.6666C14.8521 26.6648 13.7043 26.639 12.5574 26.5893L11.2187 26.5253L9.93741 26.4493L8.73741 26.3666L7.64141 26.2826C6.45183 26.1921 5.33235 25.6847 4.48014 24.8498C3.62793 24.015 3.09767 22.9061 2.98275 21.7186L2.92941 21.152L2.82941 19.9386C2.72786 18.6281 2.6736 17.3144 2.66675 16C2.66675 14.6893 2.73608 13.3186 2.82941 12.0613L2.92941 10.848L2.98275 10.2813C3.09762 9.09405 3.6277 7.98538 4.47963 7.15052C5.33157 6.31566 6.45074 5.80813 7.64008 5.71731L8.73475 5.63198L9.93475 5.55065L11.2174 5.47465L12.5561 5.41065C13.7034 5.36095 14.8517 5.33517 16.0001 5.33331ZM13.3334 12.7666V19.2333C13.3334 19.8493 14.0001 20.2333 14.5334 19.9266L20.1334 16.6933C20.2553 16.6232 20.3565 16.5221 20.4269 16.4004C20.4972 16.2787 20.5343 16.1406 20.5343 16C20.5343 15.8594 20.4972 15.7213 20.4269 15.5995C20.3565 15.4778 20.2553 15.3768 20.1334 15.3066L14.5334 12.0746C14.4118 12.0044 14.2738 11.9674 14.1333 11.9675C13.9928 11.9675 13.8548 12.0045 13.7332 12.0748C13.6116 12.1451 13.5106 12.2461 13.4404 12.3678C13.3702 12.4895 13.3333 12.6275 13.3334 12.768V12.7666Z\" fill=\"#079F72\"></path></svg></a></div>", 2)

import { ref, computed } from 'vue'
import { isPerformingRequest, useAxios } from '@/api/axios'
import router from '@/router'
import Loader from '@/components/loader/Loader.vue'
import InstallPWAModal from '@/components/modal/pwa/InstallPWAModal.vue'
import Recaptcha from '@/components/google/Recaptcha.vue'
import { recaptchaConfig } from '@/global/config/recaptcha'
import fluxooLogo from '@/assets/images/fluxoo-doc-logo.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const isLegisla = computed(() => window.location.hostname === 'legisla.fluxoo.com.br')
const showPassword = ref<boolean>(false)
const loginForm = ref<{email?:string, password?:string, token?: string, remember?:boolean}>({})
const axios = useAxios()

async function login () {
  axios.post('/login', loginForm.value)
    .then(() => {
      router.push({ name: 'admin.home' })
    })
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      (!isLegisla.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("section", null, [
        _createElementVNode("img", {
          src: isLegisla.value ? '/img/legisla/logo.svg' : _unref(fluxooLogo),
          alt: isLegisla.value ? 'Logo Legisla' : 'Logo fluxoo doc'
        }, null, 8, _hoisted_8),
        _createElementVNode("h1", null, "Bem-vindo (a) de volta ao " + _toDisplayString(isLegisla.value ? 'Fluxoo Legisla' : 'Fluxoo DOC') + ". Entre e gerencie suas operações.", 1),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = ($event: any) => ($event.preventDefault())),
          action: ""
        }, [
          _createElementVNode("section", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.value.email) = $event)),
              type: "text",
              placeholder: "ex: joaosasilva@gmail.com",
              name: "email",
              id: "email"
            }, null, 512), [
              [_vModelText, loginForm.value.email]
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.value.password) = $event)),
              type: showPassword.value ? 'text':'password',
              placeholder: "ex: 123456",
              name: "password",
              id: "password"
            }, null, 8, _hoisted_11), [
              [_vModelDynamic, loginForm.value.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
            }, [
              (showPassword.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                : (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_22))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                autocomplete: "off",
                type: "checkbox",
                name: "remember",
                id: "remember",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginForm.value.remember) = $event))
              }, null, 512), [
                [_vModelCheckbox, loginForm.value.remember]
              ]),
              _hoisted_25,
              _hoisted_26
            ]),
            _createVNode(_component_RouterLink, { to: {name: 'recover-password'} }, {
              default: _withCtx(() => [
                _createTextVNode("Esqueci a senha")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(Recaptcha, {
              sitekey: _unref(recaptchaConfig).sitekey,
              callback: (token) => loginForm.value.token = token
            }, null, 8, ["sitekey", "callback"])
          ]),
          _createElementVNode("input", {
            autocomplete: "off",
            disabled: !(loginForm.value.email && loginForm.value.password && loginForm.value.token),
            onClick: login,
            type: "button",
            value: "entrar"
          }, null, 8, _hoisted_28)
        ], 32),
        _hoisted_29
      ])
    ]),
    _createVNode(InstallPWAModal),
    (_unref(isPerformingRequest))
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          zIndex: 99
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})